import type { Plugin } from "../core/plugin";
import { PluginRegistry } from "../core/pluginRegistry";

/**
 * Sincroniza el estado visual `--selected` de `CarExtraCardB2B` con la
 * cantidad del stepper: al pasar de 0 a >0 se marca como añadido, y viceversa.
 */
export class CarExtraCardSelectionPlugin implements Plugin {
  private readonly stepperEl: HTMLElement | null;

  constructor(private readonly element: HTMLElement) {
    this.stepperEl = element.querySelector(".coreStepperV2");
  }

  init(): void {
    if (!this.stepperEl) return;
    this.stepperEl.addEventListener("stepperChange", this.handleChange);
    this.syncFromValue(parseInt(this.stepperEl.dataset.value || "0", 10));
  }

  destroy(): void {
    this.stepperEl?.removeEventListener("stepperChange", this.handleChange);
  }

  private readonly handleChange = (event: Event): void => {
    const detail = (event as CustomEvent<{ value: number }>).detail;
    this.syncFromValue(detail?.value ?? 0);
  };

  private syncFromValue(value: number): void {
    this.element.classList.toggle("car-extraCardB2B--selected", value > 0);
  }
}

PluginRegistry.register("car-extraCard-selection", CarExtraCardSelectionPlugin);
